import { useMemo } from 'react';
import { COMMON_FLAGS } from '../../../../../../taboola-common-frontend-modules/account-configurations';
import useCommonConfig from '../../../../../../taboola-common-frontend-modules/account-configurations/hooks/useCommonConfig';
import { PACING_SCORE_STATUS } from '../../../../../config/pacingScoreStatusConsts';

export const usePacingScoreStatus = value => {
    const { [COMMON_FLAGS.PACING_SCORE_STATUS_RANGE_BARRIERS]: pacingScoreStatusRangeBarriers } = useCommonConfig(
        COMMON_FLAGS.PACING_SCORE_STATUS_RANGE_BARRIERS
    );

    const status = useMemo(() => {
        const rangeIndexToStatusArray = [
            PACING_SCORE_STATUS.HIGHLY_UNDER_PACING,
            PACING_SCORE_STATUS.UNDER_PACING,
            PACING_SCORE_STATUS.ON_TRACK,
            PACING_SCORE_STATUS.OVER_PACING,
            PACING_SCORE_STATUS.HIGHLY_OVER_PACING,
        ];

        if (value == null) {
            return null;
        }
        const sortedPacingScoreStatusRangeBarriers = pacingScoreStatusRangeBarriers.sort((a, b) => a - b);
        const index = sortedPacingScoreStatusRangeBarriers.findIndex(currentValue => value < currentValue);
        const rangeIndex = index === -1 ? rangeIndexToStatusArray.length - 1 : index;
        return rangeIndexToStatusArray[rangeIndex];
    }, [value, pacingScoreStatusRangeBarriers]);

    return { status };
};
